import { Group } from "@material-ui/icons";
export const formatNumber =(value)=>{
  if (value === null || value === undefined) return "0";
  return new Intl.NumberFormat().format(value);
}
export const getTimestamp = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
};
export const updatePrices = (products) => {
  const latestPrices = {};

  products.forEach((item) => {
    const sku = item.product.sku;
    if (
      !latestPrices[sku] ||
      new Date(item.updatedAt) > new Date(latestPrices[sku].updatedAt)
    ) {
      latestPrices[sku] = {
        price: item.price,
        updatedAt: item.updatedAt,
      };
    }
  });
  return products.map((item) => {
    const sku = item.product.sku;
    return {
      ...item,
      price: latestPrices[sku].price,
    };
  });
};

export const calculateTotalSum = (orders) => {
  let totalSum = 0;
  orders.forEach((order) => {
    const totalPrice = parseFloat(order.totalPrice);
    if (!isNaN(totalPrice)) {
      totalSum += totalPrice;
    }
  });
  return totalSum.toFixed(2); // Return the total sum rounded to 2 decimal places
};
export const calculateTotalSumOrderProducts = (orders) => {
  let totalSum = 0;
  orders.forEach((order) => {
    order.orderProducts.forEach((product) => {
      const productTotalPrice = parseFloat(product.totalPrice);
      if (!isNaN(productTotalPrice)) {
        totalSum += productTotalPrice;
      }
    });
  });
  return totalSum.toFixed(2);
};

export const calculateTotalPaid = (orders) => {
  let totalSum = 0;
  orders.forEach((order) => {
    const paid = parseFloat(order.paid);
    if (!isNaN(paid)) {
      totalSum += paid;
    }
  });
  return totalSum.toFixed(2);
};
export const statues = () => {
  return ["Ordered", "Pending","Ready for Shipment","Shipped"];
};
export const paymentLists = ()=>{
  return ["Paid", "Balance"];
}

export const permissions = () => {
  return [
    { group: "Inventory", label: "Add Inventory", value: "addProduct" },
    { group: "Inventory", label: "List Inventories", value: "listAllProducts" },
    {
      group: "Inventory",
      label: "Delete Inventory by ID",
      value: "deleteProduct",
    },
    { group: "Inventory", label: "Update Inventory", value: "updateProduct" },
    { group: "Manage Staff", label: "Manage Staff", value: "manageStaff" },
    { group: "Manage Staff", label: "List Staffs", value: "listStaffs" },

    { group: "Sales", label: "Add Sales", value: "addOrder" },
    { group: "Sales", label: "List Sales", value: "viewOrders" },
    {
      group: "Sales",
      label: "Update Sales Status",
      value: "updateOrderStatus",
    },
    { group: "Customer", label: "Add Customer", value: "addCustomer" },
    { group: "Customer", label: "List Customer", value: "viewCustomer" },
    { group: "Customer", label: "Update Customer", value: "updateCustomer" },
    { group: "Customer", label: "Delete Customer", value: "deleteCustomer" },

    {
      group: "General Setting",
      label: "General Setting",
      value: "generalSetting",
    },
    {
      group: "Categories",
      label: "Manage Categories",
      value: "manageCategories",
    },
    { group: "Report", label: "Sales Report", value: "salesReport" },
    { group: "Report", label: "Inventory Report", value: "inventoryReport" },
    { group: "Report", label: "Activity Report", value: "activityReport" },
    { group: "Shipment", label: "Only mnie", value: "onlyMineShipment" },
    { group: "Shipment", label: "View All", value: "viewAllShipment" },
  ];
};
